import { defineStore } from 'pinia';
import * as bootstrap from "bootstrap";
import { ref, Ref } from 'vue';

export const useLoginStore = defineStore('login',() => {
    const modeloginmodal: Ref<number> = ref(0);
    const descloginreferer: Ref<string> = ref('');
    const modalconn: Ref<any> = ref(null);
    const modejetable: Ref<boolean> = ref(false);

        function DCOpenLoginModal(event: any, descloginref: string = "") {
            DCOpenLoginModalAux(event, 0,false, descloginref);
    }

    function DCOpenLoginModalAux(event: any, modeloginmodalaux: number, modejetableaux:boolean, descloginref: string) {
        if (event != null)
            event.preventDefault();
        modeloginmodal.value = modeloginmodalaux;
        modejetable.value = modejetableaux;
        descloginreferer.value = descloginref;
        let elt = document.getElementById('dc_logindialog');
        if (elt !== null) {
            modalconn.value = new bootstrap.Modal(elt, {});
            modalconn.value.show();
        }
    }

    function DCCreateAccount(event: any, jetable:boolean) {
        DCOpenLoginModalAux(event, 1, jetable, '');
    }

    function setmodeloginmodal(modeloginmodalvar: number) {
        modeloginmodal.value = modeloginmodalvar;
    }

    function setdescloginreferer(descloginreferervar: string) {
        descloginreferer.value = descloginreferervar;
    }

    return { modeloginmodal, descloginreferer, modalconn, modejetable, DCOpenLoginModal, DCCreateAccount, setmodeloginmodal, setdescloginreferer };
});